import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Footer extends Component {
    render() {
        return (
            <section className="footer pt-120 dark-bg">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 me-auto col-sm-6 col-md-12">
                            <div className="widget footer-widget mb-5 mb-lg-0">
                                <h5 className="widget-title">ExpertEdge Publications</h5>
                                <p className="mt-3">We are dedicated to bringing you the finest e-books authored by experts in their respective fields. Our platform is a hub of knowledge, designed to inspire, educate, and empower readers worldwide.</p>
                            </div>
                        </div>

                        <div className="col-lg-6 col-sm-6 col-md-12">
                            <div className="footer-widget mb-5 mb-lg-0">
                                <h5 className="widget-title">We Offer</h5>
                            </div>
                            <div className="row">
                                <div className="col-lg-5 col-md-6">
                                    <ul className="list-unstyled footer-links">
                                        <li><Link to="#">Expertly Written Content</Link></li>
                                        <li><Link to="#">Wide Range of Topics</Link></li>
                                        <li><Link to="#">Convenient Access</Link></li>
                                        <li><Link to="#">Affordable Knowledge</Link></li>
                                    </ul>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="footer-widget footer-contact mb-5 mb-lg-0">
                                        <ul className="list-unstyled">
                                            <li> +91 7219509422</li>
                                            <li>864, A ward, B 3 & 4, Prathmesh Nagar, Near Survey Nagar, Kalamba Ring Road, Kolhapur 416007</li>
                                            <li>expertedgepublications@gmail.com</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-btm">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="copyright">
                                    <p>@ 2025-Copyright reserved to ExpertEdge Publications. Proudly Crafted by <Link to="https:/webthoughts.in">WebThoughts Technologies</Link> </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <div className="fixed-btm-top">
                    <a href="#top-header" className="js-scroll-trigger scroll-to-top"><i className="fa fa-angle-up"></i></a>
                </div>
            </section>


        );
    }
}

export default Footer;
